module.exports = __webpack_public_path__ + "static/media/che4.edcc651c.png";